
import { call, put, takeEvery } from "redux-saga/effects"

import { GET_ADMIN_STATS } from "./actionTypes"
import { getAdminStatsSuccess, getAdminStatsFail } from "./actions"
import { getAdminDashboardStats } from "../../helpers/fakebackend_helper"

function* fetchAdminStats() {
    try {
        const response = yield call(getAdminDashboardStats)
        yield put(getAdminStatsSuccess(response))
    } catch (error) {
        yield put(getAdminStatsFail(error))
    }
}

function* dashboardAdminSaga() {
    yield takeEvery(GET_ADMIN_STATS, fetchAdminStats)
}

export default dashboardAdminSaga
